import createStore from ".";

export const {store, persistor} = createStore();